import { createContext as t } from "react";
const n = t(null);
export {
  n as TenantContext
};
